// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

import { useEffect, useRef } from "react";

// EmojiPicker is a full emoji picker (search + categories + skin tones) shared by the message
// composer and in-call reactions. It uses emoji-mart's FRAMEWORK-AGNOSTIC core (the React
// wrapper doesn't support React 19) mounted into a host div, and both the picker JS + its
// ~1.5 MB emoji data are DYNAMICALLY imported on first open — so the main bundle stays lean.
export function EmojiPicker({ onPick }: { readonly onPick: (native: string) => void }) {
  const host = useRef<HTMLDivElement | null>(null);
  const onPickRef = useRef(onPick);
  onPickRef.current = onPick;
  useEffect(() => {
    let el: HTMLElement | null = null;
    let alive = true;
    void Promise.all([import("emoji-mart"), import("@emoji-mart/data")]).then(([mart, data]) => {
      if (!alive || !host.current) return;
      el = new mart.Picker({
        data: (data as { default: unknown }).default,
        theme: "dark",
        previewPosition: "none",
        skinTonePosition: "search",
        onEmojiSelect: (e: { native: string }) => onPickRef.current(e.native),
      }) as unknown as HTMLElement;
      host.current.replaceChildren(el);
    });
    return () => {
      alive = false;
      el?.remove();
    };
  }, []);
  return <div ref={host} className="emoji-picker-host" />;
}
